// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0a7999f3","488":"fe87d753"}[chunkId] + ".chunk.js";
};